<c-container class="pt-3">
  <div style="display: flex;align-items: center; margin-bottom: 1rem;" *ngIf="isRepairerDetailRoute">
    <h2 style="display: inline;margin-right: 1rem;">Repairer Summary for:
    </h2>
    <div>
      <select *ngIf="currentRepairerDetail" style="width: auto;" aria-label="Default select example" cSelect sizing="lg" (change)="navigateToDepotRepairer($event)" [disabled]="!currentRepairerDetail">
        <option *ngFor="let repairer of repairersDetailData" [selected]="currentRepairerDetail.id == repairer.id ? 'checked' : null" [value]="repairer.id">{{repairer.name}}</option>
      </select>
    </div>
   
    <div class="back-to-list d--f ai--c ml-auto"> 
        <!-- <button class="btn btn-secondary" cButton color="light" variant="outline" (click)="backClicked()">Back to list</button> -->
        <svg [cIcon]="icons.cilArrowLeft" size="sm" title="Back to list" class="back-to-list__icon"></svg>
        <a cButton color="light" (click)="backClicked()" role="button">Back to list</a>
    </div>
  </div>

  <!-- <div style="display: flex;align-items: center; margin-bottom: 1rem;" *ngIf="!currentRepairerDetail">
    <h2 style="display: inline;margin-right: 1rem;">Repairer Summary for 
    </h2>
  </div> -->

  <c-row *ngIf="!isRepairerDetailRoute">
    <c-col class="col-lg-12" >
      <c-card>
        <c-card-body>
          <c-chart [data]="repairerSummaryData" type="line" (chartRef)="handleChartRef($event)"
            [options]="repairerSummaryOptions" height="450" 
           />
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
  <c-row class="mt-3">
    <c-col>
      <router-outlet />
      <!-- <c-card>
        <c-card-header class="card-header" *ngIf="!currentRepairerDetail">
          <h4 class="card-header__heading">Average time at repairer (Last 30 days)</h4>
        </c-card-header>
        <c-card-body>
          <router-outlet />
        </c-card-body>
      </c-card> -->
    </c-col>

  </c-row>

</c-container>